import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppBreadcrumbService } from '../../app.breadcrumb.service';
import { FileUpload } from 'primeng/fileupload';
import { NgForm } from '@angular/forms';
import { ValidateformComponent } from '../../common/validateform/validateform.component';
import { Message } from 'primeng/api/message';
import { LookupValuesService } from '../../common/lookup-values.service';
import { environment } from '../../../environments/environment';
import { MessageService } from '../../services/MessageService';
import { ConfirmationService } from 'primeng/api';
import { AlertService } from 'src/app/services/AlertService';

@Component({
  selector: 'app-message-add',
  templateUrl: './message-add.component.html',
  styleUrls: ['./message-add.component.scss']
})
export class MessageAddComponent implements OnInit {
    @ViewChild(FileUpload) pFileUpload: FileUpload;
    @ViewChild('f', { static: true }) addMessageForm: NgForm;
    @ViewChild(ValidateformComponent, { static: true })
    private formValidator: ValidateformComponent;
    msgs: Message[];

    options: any
    message: any;
    propertyTypeOptions: any[] = [];
    dealTypeOptions: any[] = [];
    countryOptions: any[] = [];
    regionOptions: any[] = [];
    stateOptions: any[] = [];
    currentUser: any;
    isReviewing: boolean = false;

    messageId: any;
    uploadURL: string = environment.apiBase.concat("News/UploadMessageDocuments");

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private breadcrumbService: AppBreadcrumbService,
                private lookupValuesService: LookupValuesService,
                private messageService: MessageService,
                private confirmationService: ConfirmationService,
                private alertService: AlertService
                ) { }

    ngOnInit(): void {
        this.breadcrumbService.setItems([
            this.breadcrumbService.messageBoard,
            this.breadcrumbService.messageAdd,
        ]);

        this.options = this.activatedRoute.snapshot.data['options'];
        this.parseOptions();
        this.initMessage();
    }

    parseOptions() {
        this.propertyTypeOptions = new Array();
        for (let o of this.options[0]) {
            let l = o.Description;
            this.propertyTypeOptions.push({ label: l, value: o.Id });
        }

        this.dealTypeOptions = new Array();
        for (let o of this.options[1]) {
            let l = o.Description;
            this.dealTypeOptions.push({ label: l, value: o.Id });
        }

        this.countryOptions = new Array();
        for (let o of this.options[2]) {
            let l = o.Name;
            this.countryOptions.push({ label: l, value: o.Id });
        }
        //move us to the top
        if (this.countryOptions != undefined && this.countryOptions.length > 0) {
            this.countryOptions.unshift(this.countryOptions.splice(this.countryOptions.findIndex(item => item.value === 221), 1)[0])
        }
      
        this.regionOptions = new Array();
        for (let o of this.options[3]) {
            let l = o.Name;
            this.regionOptions.push({ label: l, value: o.Id });
        }

        this.currentUser = this.options[4];
    }

    initMessage() {
        this.message = {};
        this.message.Active = true;
        this.message.Archived = false;
        this.message.MessageSourceTypeID = 1;
        this.message.Documents = [];
        this.message.HeadLine = '';
        this.message.BroadcastBody = '';
        this.message.DealTypeID = 1;
        this.message.PropertyTypeID = 1;
        this.message.CountryID = 221;
        this.message.StateID = null;
        this.message.City = '';
        this.message.ContactName = this.currentUser.UserProfile.FName + ' ' + this.currentUser.UserProfile.LName;
        this.message.ContactEmail = this.currentUser.Email;
        this.message.ContactPhone = '';
        this.message.AdminEmail = '';      
        this.onCountryChange();
    }

    reviewMessage() {
        this.message.PropertyTypeName = this.propertyTypeOptions.find(p => p.value == this.message.PropertyTypeID).label;
        this.message.DealTypeName = this.dealTypeOptions.find(d => d.value == this.message.DealTypeID).label;
        if (this.stateOptions.find(p => p.value == this.message.StateID) != undefined) {
            this.message.StateName = this.stateOptions.find(p => p.value == this.message.StateID).label;
        }
        if (this.countryOptions.find(d => d.value == this.message.CountryID) != undefined) {
            this.message.CountryName = this.countryOptions.find(d => d.value == this.message.CountryID).label;
        }            
        this.message.Attachments = this.pFileUpload.files;

        if (this.formValidator.validateForm()) {
            this.isReviewing = true;
          
        }
    }

    onReviewBackToEdit() {
        this.isReviewing = false;
    }

    onReviewCompletedAndSubmit() {
        this.messageService.addMessage(this.message).subscribe(
            result => {
                this.messageId = result.Id;
                if (this.pFileUpload.files.length > 0) {
                    this.pFileUpload.upload();
                }
                else {                  
                    this.router.navigate(['/message/view']);
                    this.alertService.SetMessage('success', 'New message was sent.');
                }
            },
            error => {
                this.alertService.SetMessage('error', 'There is an error while adding message');
            }
        );
    }

    onCountryChange() {
        if (this.message.CountryID != null) {
            this.lookupValuesService.GetStateOptions(this.message.CountryID).subscribe(
                res => {
                    this.stateOptions = new Array();
                    for (let o of res) {
                        let l = o.Name;
                        this.stateOptions.push({ label: l, value: o.Id });
                    }
                },
                error => {
                    this.alertService.SetMessage('error', 'There is an error while getting states');
                }
            )
        }
    }

    onBeforeUpload(event) {
        if (this.messageId != undefined && this.messageId != 0) {
            event.formData.append('MessageId', this.messageId);
            event.formData.append('Description', 'Message Document');
        }
        else {
            event.xhr.abort();
            event.xhr = null;
            event.stopPropogation();
            this.alertService.SetMessage('error', 'There is an error while uploading file');
        }
    }

    onUploadCompleted(event) {
        if (event.originalEvent.ok) {
            this.router.navigate(['/message/view']);
            this.alertService.SetMessage('success', 'New message is added.');
        }
        else {
            this.alertService.SetMessage('error', 'There is an error while uploading file');
        }
    }

    cancelAddMessage() {
        this.confirmationService.confirm({
            key: "AddMessageConfirmDialog",
            message: 'Are you sure that you want to Cancel? You will lose all changes made.',
            accept: () => {
                this.router.navigate(['/message/view']);
            }
        });
    }
}
